import { useFlightStyles, useModuleBEM } from "@b2bportal/core-themes";
import { CoreFlightsComponent } from "@b2bportal/core-types";
import { FilterList } from "@tenant/flights";
import { useFlightSlot } from "../../../../slots";
import defaultStyles from "./Filters.module.scss";

export const Filters = ({ sliceIndex }: { sliceIndex: number }) => {
  const styles = useFlightStyles(CoreFlightsComponent.Filters, defaultStyles);
  const [block, cn] = useModuleBEM(styles, CoreFlightsComponent.Filters);
  const FlightSlot = useFlightSlot();

  return (
    <div className={block}>
      <FlightSlot.FilterDialog sliceIndex={sliceIndex} />
      <FilterList className={cn("filter-list")} sliceIndex={sliceIndex} />
    </div>
  );
};
